export default "__VITE_ASSET__CELT3lKl__"